import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "container",
  style: {"text-align":"left"}
}
const _hoisted_2 = { style: {"color":"red","font-weight":"bold","font-size":"larger"} }
const _hoisted_3 = { class: "gutter-box" }
const _hoisted_4 = { class: "gutter-box" }
const _hoisted_5 = { style: {"color":"red","font-weight":"bold","font-size":"larger"} }

import { searchInstance } from "@/api/order";
import { onMounted, reactive, UnwrapRef } from "vue";
import { finishTask } from "@/api/home";
import { useRoute, useRouter } from "vue-router";
import { message } from "ant-design-vue";
import { searchDentistTeam } from "@/api/dentist_team";
import { debounce } from 'lodash-es';

interface Lists {
  online: {
    pagination: any,
    data: []
  },
  facial: {
    pagination: any,
    data: []
  },
  dentists: any[],
  loading: boolean,
  fetching: boolean
}


interface SelectedOrderIds {
  oralDetectionOrderId: number,
  facialOrderId: number;
  dentistId: string | number,
}



export default /*#__PURE__*/_defineComponent({
  __name: 't103',
  setup(__props) {


const route = useRoute();
const router = useRouter();

const columns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "姓名",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "电话",
    dataIndex: "mobile",
    key: "mobile",
  },
  {
    title: "订单类型",
    dataIndex: "typeStr",
    key: "typeStr",
  },
  {
    title: "操作",
    dataIndex: "operation",
    key: "operation",
  },
];

let selectedOrderIds: UnwrapRef<SelectedOrderIds> = reactive({
  oralDetectionOrderId: 0,
  facialOrderId: 0,
  dentistId: '',
});


let lists: UnwrapRef<Lists> = reactive({
  online: {
    pagination: {
      size: "small",
      current: 1,
      pageSize: 10,
      total: 0,
      pageSizeOptions: ["10", "20", "30"],
      showTotal: (total: string) => {
        return " 共" + total + "条";
      },
      hideOnSinglePage: false,
      showSizeChanger: true,
    },
    data: []
  },
  facial: {
    pagination: {
      size: "small",
      current: 1,
      pageSize: 10,
      total: 0,
      pageSizeOptions: ["10", "20", "30"],
      showTotal: (total: string) => {
        return " 共" + total + "条";
      },
      hideOnSinglePage: false,
      showSizeChanger: true,
    },
    data: []
  },
  dentists: [],
  loading: false,
  fetching:false
})

const isAllSet = () => {
  return selectedOrderIds.oralDetectionOrderId > 0 && selectedOrderIds.facialOrderId > 0 && selectedOrderIds.dentistId
}

const finishTaskT103 = () => {
  lists.loading = true;
  let processDefinitionId = route.query.processDefinitionId;
  let processInstanceId = route.query.processInstanceId;
  let processDefinitionKey = route.query.processDefinitionKey;
  let runTimeTaskId = route.query.runTimeTaskId;
  let taskCode = route.query.taskCode

  let parameters = {
    processDefinitionId: processDefinitionId,
    processInstanceId: processInstanceId,
    processDefinitionKey: processDefinitionKey,
    runTimeTaskId: runTimeTaskId,
    taskCode: taskCode,
    params: {
      dentistId: selectedOrderIds.dentistId,
      oralDetectionOrderId: selectedOrderIds.oralDetectionOrderId,
      facialDetectionId: selectedOrderIds.facialOrderId
    }
  };

  finishTask(parameters).then(() => {
    message.success("操作成功");
    lists.loading = false;
    router.push({
      path: "/home",
    });
  });
}
let lastFetchId = 0;
const onDentistTeamSearch = debounce((keyword: string) => {
  lastFetchId += 1;
  const fetchId = lastFetchId;
  lists.fetching = true;
  lists.dentists = []
  let parameters = { keyword: keyword, page: { currPage: 1, pageSize: 100 } }
  searchDentistTeam(parameters).then((res: { records: number; data: any[] }) => {
    if (fetchId !== lastFetchId) {
      // for fetch callback order
      return;
    }
    if (!res.data) return;
    res.data.forEach((x) => {
      if (null != x.principal)
        lists.dentists.push({ label: x.name, value: x.principal.id })
    });
    lists.fetching = false;
  });
}, 300)

const onSelectOnlineOrder = (record: any) => {
  selectedOrderIds.oralDetectionOrderId = record.id;
}

const onSelectFacialOrder = (record: any) => {
  selectedOrderIds.facialOrderId = record.id;
}

const onOnlinePageChange = (page: any,type:number) => {
  if(type == 1){
    lists.online.pagination.pageSize = page.pageSize;
    lists.online.pagination.current = page.current;
    getOralDetectionOrders();
  }else{
    lists.facial.pagination.pageSize = page.pageSize;
    lists.facial.pagination.current = page.current;
    getOralFacialOrders();
  }
}

const getOralDetectionOrders = () => {
  let parameters: any = {
    type: route.query.type,
    completed: true,
    includeCancel: false,
    reported: 1,
    // reported: 0,
    relatedId:route.query.patientId,
    page: {
      currPage: lists.online.pagination.current,
      pageSize: lists.online.pagination.pageSize
    },
    
  }
  // if (route.query.processDefinitionKey == 'P05') {
  //   parameters.reported = 1
  // } else {
  //   parameters.rptOralOrthodonticDesignState = 1
  // }
  searchInstance(parameters).then((res: any) => {
    if (res) {
      lists.online.pagination.total = res.records;
      lists.online.data = res.data;
    }
  });
}

const getOralFacialOrders = () => {
  let parameters: any = {
    type: 2,
    completed: true,
    reported: 1,
    includeCancel: false,
    relatedId:route.query.patientId,
    page: {
      currPage: lists.facial.pagination.current,
      pageSize: lists.facial.pagination.pageSize
    }
  }

  searchInstance(parameters).then((res: any) => {
    if (res) {
      lists.facial.pagination.total = res.records;
      lists.facial.data = res.data;
    }
  });
}

const init = () => {
  getOralFacialOrders();
  getOralDetectionOrders();
}


onMounted(() => {
  init();
  onDentistTeamSearch('');
})



return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createTextVNode(" 请选择医生: "),
            _createVNode(_component_a_select, {
              style: {"width":"200px"},
              value: _unref(selectedOrderIds).dentistId,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(selectedOrderIds).dentistId) = $event)),
              "show-search": "",
              placeholder: "请输入查询关键写",
              "filter-option": false,
              "not-found-content": _unref(lists).fetching ? undefined : null,
              options: _unref(lists).dentists,
              onSearch: _unref(onDentistTeamSearch),
              "default-active-first-option": false,
              "show-arrow": false
            }, _createSlots({ _: 2 }, [
              (_unref(lists).fetching)
                ? {
                    name: "notFoundContent",
                    fn: _withCtx(() => [
                      _createVNode(_component_a_spin, { size: "small" })
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["value", "not-found-content", "options", "onSearch"]),
            (isAllSet())
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  onClick: finishTaskT103,
                  type: "primary",
                  loading: _unref(lists).loading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("提交")
                  ]),
                  _: 1
                }, 8, ["loading"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { gutter: 16 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          class: "gutter-row",
          span: 10
        }, {
          default: _withCtx(() => [
            (_unref(selectedOrderIds).oralDetectionOrderId > 0)
              ? (_openBlock(), _createBlock(_component_a_divider, { key: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 口腔检测订单: "),
                    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(selectedOrderIds).oralDetectionOrderId), 1)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_a_divider, { key: 1 }, {
                  default: _withCtx(() => [
                    _createTextVNode("口腔检测订单:无")
                  ]),
                  _: 1
                })),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_a_table, {
                dataSource: _unref(lists).online.data,
                columns: columns,
                pagination: _unref(lists).online.pagination,
                scroll: { y: 400 },
                size: "small",
                onChange: _cache[1] || (_cache[1] = (page)=>onOnlinePageChange(page,1))
              }, {
                bodyCell: _withCtx(({ column, record }) => [
                  (column.dataIndex === 'operation')
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        type: "primary",
                        onClick: ($event: any) => (onSelectOnlineOrder(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("选择")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["dataSource", "pagination"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          class: "gutter-row",
          span: 10
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              (_unref(selectedOrderIds).facialOrderId > 0)
                ? (_openBlock(), _createBlock(_component_a_divider, { key: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 面部照订单: "),
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(selectedOrderIds).facialOrderId), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_a_divider, { key: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode("面部照订单:无")
                    ]),
                    _: 1
                  })),
              _createVNode(_component_a_table, {
                dataSource: _unref(lists).facial.data,
                columns: columns,
                pagination: _unref(lists).facial.pagination,
                scroll: { y: 400 },
                size: "small",
                onChange: _cache[2] || (_cache[2] = (page)=>onOnlinePageChange(page,2))
              }, {
                bodyCell: _withCtx(({ column, record }) => [
                  (column.dataIndex === 'operation')
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        type: "primary",
                        onClick: ($event: any) => (onSelectFacialOrder(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("选择")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["dataSource", "pagination"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})